const keyboardDatePickerModalDocEmployee = {
  label: 'Duracion'
};

export default keyboardDatePickerModalDocEmployee;
